// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Calendar__Wrapper_2NoyF","Title":"Calendar__Title_3rEX6","Events":"Calendar__Events_2OWgL grid grid--col-12"};